export default __webpack_public_path__ + "static/valerio-buzzelli-1fdb4ad0d35e33b1a69b424f87757b71.jpg";